function createGifLikeAnimationFromData(canvasId, frameCount, fps = 6) {
    const canvas = document.getElementById(canvasId);
    const ctx = canvas.getContext('2d');
    const src = canvas.getAttribute('data-src'); // vd: "assets/dream-ms-float_bottom/images/"
    const frameUrls = [];

    // Tạo danh sách đường dẫn ảnh
    for (let i = 1; i <= frameCount; i++) {
        frameUrls.push(`${src}/cat_${i}.png`);
    }

    let frames = [];
    let currentFrame = 0;
    let playing = true;
    let loaded = 0;

    // Tải tất cả ảnh
    frameUrls.forEach((url, i) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            loaded++;
            if (loaded === frameUrls.length) start();
        };
        frames[i] = img;
    });

    function start() {
        function draw() {
            if (!playing) return;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(frames[currentFrame], 0, 0, canvas.width, canvas.height);
            currentFrame = (currentFrame + 1) % frames.length;
            setTimeout(draw, 1000 / fps);
        }
        draw();
    }

    return {
        stop: () => playing = false,
        play: () => { if (!playing) { playing = true; start(); } }
    };
}

window.addEventListener("load", function () {
    
    // Ví dụ: nếu bạn có 30 frame cho mỗi con mèo
    createGifLikeAnimationFromData('cat-canvas', 30, 15);

    const mainSwiper = $('.main-swiper')[0].swiper;

    // Object mapping button class to slide index
    const buttonMap = {
        'btn-home': 0,   // Trang chủ
        'btn-news': 1,   // Tin tức
        'btn-dsp': 2,  // Danh sĩ phố (nếu có slide)
        'btn-dtq': 3   // Đồ thư quán (nếu có slide)
    };

    // Function để cập nhật class active cho buttons
    function updateActiveButton(activeIndex) {
        // Remove active class từ tất cả buttons
        $('#dream-ms-float_bottom .list-btns a').removeClass('active');

        // Tìm button tương ứng với slide index và thêm active class
        Object.keys(buttonMap).forEach(btnClass => {
            if (buttonMap[btnClass] === activeIndex) {
                $(`#dream-ms-float_bottom .${btnClass}`).addClass('active');
            }
        });
    }

    // Cập nhật active button khi load trang
    updateActiveButton(mainSwiper.activeIndex);

    // Listen cho sự kiện slide change của swiper
    mainSwiper.on('slideChange', function () {
        updateActiveButton(mainSwiper.activeIndex);
    });

    // Bind click events cho tất cả buttons
    Object.keys(buttonMap).forEach(btnClass => {
        $(`#dream-ms-float_bottom .${btnClass}`).on('click', function (e) {
            e.preventDefault();
            mainSwiper.slideTo(buttonMap[btnClass]);
            // updateActiveButton sẽ được gọi tự động qua slideChange event
        });
    });

});

